<template>
  <div class="bg">
    <div class="content">
      <el-form
        ref="infoForm"
        :model="infoForm"
        :rules="rules"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-form-item label="大头照：" prop="head">
            <el-upload
              id="upload"
              class="avatar-uploader"
              action="#"
              :http-request="uploadPic"
              accept="image/*"
              capture="camera"
              :show-file-list="false"
              :on-change="handlePictureCardPreviewHead"
              :on-progress="uploadVideoProcess"
            >
              <el-image
                v-if="head"
                :src="head"
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress
                v-if="progressFlag"
                :percentage="loadProgress"
              ></el-progress>
            </el-upload>
            <!-- vueCropper 剪裁图片实现-->
            <el-dialog
              title="图片剪裁"
              :visible.sync="dialogVisible"
              append-to-body
            >
              <div class="cropper-content">
                <div class="cropper" style="text-align: center">
                  <vueCropper
                    ref="cropper"
                    :img="option.img"
                    :outputSize="option.size"
                    :outputType="option.outputType"
                    :info="true"
                    :full="option.full"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :autoCrop="option.autoCrop"
                    :fixed="option.fixed"
                    :fixedNumber="option.fixedNumber"
                    :centerBox="option.centerBox"
                    :infoTrue="option.infoTrue"
                    :fixedBox="option.fixedBox"
                  ></vueCropper>
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish" :loading="loading">
                  确认
                </el-button>
              </div>
            </el-dialog>
            <p>
              <i>（要求:只有一个人脸、五官清晰、不能遮挡）</i>
            </p>
          </el-form-item>
          <el-form-item label="身份证：" prop="front">
            <el-upload
              class="avatar-uploader"
              action="#"
              :http-request="uploadPic"
              accept="image/*"
              capture="camera"
              :show-file-list="false"
              :on-change="handlePictureCardPreviewFront"
            >
              <el-image
                v-if="front"
                :src="front"
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i>（头像面）</i>
          </el-form-item>
          <el-form-item prop="back">
            <el-upload
              class="avatar-uploader"
              action="#"
              :http-request="uploadPic"
              accept="image/*"
              capture="camera"
              :show-file-list="false"
              :on-change="handlePictureCardPreviewBack"
            >
              <el-image
                v-if="back"
                :src="back"
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i>（国徽面）</i>
          </el-form-item>
          <p></p>
          <div v-if="this.$route.params.addOrEdit == '0'">
            <el-form-item label="所属项目：" prop="projectId">
              <span>{{ projectId }}</span>
            </el-form-item>

            <el-form-item label="参建单位：">
              <span @click="Unit">{{ unit }}</span>
              <van-popup
                v-model="showUnitPopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择参建单位"
                  show-toolbar
                  :columns="unitOptions"
                  @confirm="onConfirmUnit"
                  @cancel="showUnitPopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="所属班组：">
              <span @click="showTeamPopup = true">{{ team }}</span>
              <van-popup
                v-model="showTeamPopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择所属班组"
                  show-toolbar
                  :columns="teamOptions"
                  @confirm="onConfirmTeam"
                  @cancel="showTeamPopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="人员类型：">
              <span @click="showPersonnelTypePopup = true">
                {{ personnelType }}
              </span>
              <van-popup
                v-model="showPersonnelTypePopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择人员类型"
                  show-toolbar
                  :columns="personnelTypeOptions"
                  @confirm="onConfirmPersonnelType"
                  @cancel="showPersonnelTypePopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item v-if="showPost" label="管理岗位：">
              <span @click="showPostPopup = true">{{ post }}</span>
              <van-popup
                v-model="showPostPopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择管理岗位"
                  show-toolbar
                  :columns="postOptions"
                  @confirm="onConfirmPost"
                  @cancel="showPostPopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="所属工种：" prop="workType">
              <span @click="showWorkTypePopup = true">{{ workType }}</span>
              <van-popup
                v-model="showWorkTypePopup"
                round
                position="bottom"
                :style="{
                  height: 45,
                }"
              >
                <van-picker
                  title="请选择所属工种"
                  show-toolbar
                  :columns="workTypeOptions"
                  @confirm="onConfirmWorkType"
                  @cancel="showWorkTypePopup = false"
                />
              </van-popup>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input
                v-model="infoForm.phone"
                placeholder="请输入联系号码"
              ></el-input>
            </el-form-item>
          </div>
        </el-card>
      </el-form>
      <div class="btn">
        <el-button type="info" @click="authenticationHistory">
          实名认证记录
        </el-button>
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { postFile } from "@/api/file";
  import { compress } from "@/utils/file";
  import { postDictCode } from "@/api/dict";
  import { filtration$ } from "@/utils/admin";
  import formRules from "@/utils/formRules.js";
  import { postListUnit } from "@/api/app/unit";
  import { postUpLoad } from "@/api/app/upload";
  import { postListPage } from "@/api/app/enterprise";
  import { postListTeam, postTeamDetail } from "@/api/app/team";
  import { getProjectList, postProjectId } from "@/api/app/project";
  import { postDetail, postSubmitForm } from "@/api/app/certificationRecord";
  let headSuccess = 0;
  let frontSuccess = 0;
  let backSuccess = 0;
  export default {
    data() {
      return {
        dialogImageUrl: "",
        upload: "",
        // 所属项目
        // projectOptions: [],
        // showProjectPopup: false,
        projectId: "",
        loadProgress: 0, // 动态显示进度条
        progressFlag: false, // 关闭进度条
        // 参建单位
        unitOptions: [],
        unit: "请选择参建单位",
        showUnitPopup: false,
        // 所属班组
        teamOptions: [],
        team: "请选择所属班组",
        showTeamPopup: false,
        // 人员类型
        personnelType: "请选择人员类型",
        personnelTypeOptions: [
          { text: "管理人员", value: 10 },
          { text: "建筑工人", value: 20 },
        ],
        showPersonnelTypePopup: false,
        // 管理岗位
        post: "请选择管理岗位",
        showPost: false,
        postOptions: [],
        showPostPopup: false,
        // 所属工种
        workType: "请选择所属工种",
        workTypeOptions: [],
        showWorkTypePopup: false,
        // 大头照
        head: "",
        // 国徽面
        back: "",
        // 头像面
        front: "",
        // 新增信息表单
        infoForm: {
          workType: "",
        },
        // 编辑信息表单
        infoEditForm: {},
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: "", // 裁剪图片的地址
          info: true, // 裁剪框的大小信息
          outputSize: 1, // 裁剪生成图片的质量
          outputType: "jpeg", // 裁剪生成图片的格式
          canScale: false, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          // autoCropWidth: 300, // 默认生成截图框宽度
          // autoCropHeight: 200, // 默认生成截图框高度
          fixedBox: false, // 固定截图框大小 不允许改变
          fixed: false, // 是否开启截图框宽高固定比例
          // fixedNumber: [6, 6], // 截图框的宽高比例
          full: true, // 是否输出原图比例的截图
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        // 防止重复提交
        loading: false,
        // 验证规则
        rules: {
          head: [{ required: true, message: "大头照不能为空" }],
          front: [{ required: true, message: "身份证照片不能为空" }],
          back: [{ required: true, message: "身份证照片不能为空" }],
          projectId: [{ required: true, message: "所属项目不能为空" }],
          workType: [{ required: true, message: "人员类型不能为空" }],
          phone: [
            { validator: formRules.validatePhone, trigger: "blur" },
            { required: true, message: "联系号码不能为空" },
          ],
        },
      };
    },
    created() {
      this.$store.dispatch("submitToken");
      this.options();
      if (this.$route.params.addOrEdit == "1") {
        this.detail();
      }
    },
    methods: {
      uploadVideoProcess(event, file, fileList) {
        this.progressFlag = true; // 显示进度条
        this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
        if (this.loadProgress >= 100) {
          this.loadProgress = 100;
          setTimeout(() => {
            this.progressFlag = false;
          }, 1000); // 一秒后关闭进度条
        }
      },
      uploadPic() {},
      // 大头照照片上传
      handlePictureCardPreviewHead(file) {
        if (file.status == "ready") {
          let _that = this;
          let params = {};
          params.folderName = "big_head_photo";
          const isLt15M = file.size / 1024 / 1024 < 15;
          const isLt1M = file.size / 1021 / 1024 < 0.5;
          if (!isLt15M) {
            _that.$notify({
              type: "error",
              message: "上传图片大小不能超过 15M！",
            });
            return false;
          } else {
            this.dialogVisible = true;
            this.option.img = URL.createObjectURL(file.raw);
          }
        }
      },
      // 裁切确认后上传
      finish() {
        let _that = this;
        let params = {};
        params.folderName = "big_head_photo";
        this.$refs.cropper.getCropBlob((data) => {
          let name = new Date().getTime() + ".jpeg";
          const file = new window.File([data], name, {
            type: "image/jpeg",
          });
          compress(file, function(data) {
            let Orientation = null;
            let newFile = new window.File([data], file.name, {
              type: file.type,
            });
            let reader = new FileReader();
            reader.readAsDataURL(newFile);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace(
                  "data:image/png;base64,",
                  ""
                );
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  _that.head = res.data.url;
                  _that.infoForm["head"] = res.data.path;
                  _that.infoEditForm["head"] = res.data.path;
                  _that.dialogVisible = false;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  headSuccess = 1;
                } else {
                  _that.$notify({
                    type: "error",
                    message: "照片选择失败！请重新选择。",
                  });
                }
              });
            };
          });
        });
      },
      // 头像面上传
      handlePictureCardPreviewFront(file) {
        if (file.status == "ready") {
          let _that = this;
          let params = {};
          // params.format = "jpeg";
          params.folderName = "big_head_photo";
          const isLt15M = file.size / 1024 / 1024 < 15;
          const isLt1M = file.size / 1021 / 1024 < 1;
          if (!isLt15M) {
            _that.$notify({
              type: "error",
              message: "上传图片大小不能超过 15M！",
            });
            return false;
          } else if (isLt1M) {
            let reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace(
                  "data:image/png;base64,",
                  ""
                );
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  _that.front = res.data.url;
                  _that.infoForm["front"] = res.data.path;
                  _that.infoEditForm["front"] = res.data.path;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  frontSuccess = 1;
                } else {
                  _that.$notify({
                    type: "error",
                    message: "照片选择失败！请重新选择。",
                  });
                }
              });
            };
          } else {
            compress(file.raw, function(val) {
              let newFile = new window.File([val], file.name, {
                type: file.raw.type,
              });
              // newFile.uid = file.uid;
              let reader = new FileReader();
              reader.readAsDataURL(newFile);
              reader.onload = (e) => {
                if (e.currentTarget.result.search("png") !== -1) {
                  params.format = "png";
                  let base64 = e.currentTarget.result.replace(
                    "data:image/png;base64,",
                    ""
                  );
                  params.content = base64;
                }
                if (e.currentTarget.result.search("jpeg") !== -1) {
                  params.format = "jpeg";
                  let base64 = e.currentTarget.result.replace(
                    "data:image/jpeg;base64,",
                    ""
                  );
                  params.content = base64;
                }
                postFile(params).then((res) => {
                  if (res.code == 200) {
                    _that.front = res.data.url;
                    _that.infoForm["front"] = res.data.path;
                    _that.infoEditForm["front"] = res.data.path;
                    _that.$notify({
                      type: "success",
                      message: "照片选择成功！",
                    });
                    frontSuccess = 1;
                  } else {
                    _that.$notify({
                      type: "error",
                      message: "照片选择失败！请重新选择。",
                    });
                  }
                });
              };
            });
          }
        }
      },
      // 国徽面上传
      handlePictureCardPreviewBack(file) {
        if (file.status == "ready") {
          let _that = this;
          let params = {};
          // params.format = "jpeg";
          params.folderName = "big_head_photo";
          const isLt15M = file.size / 1024 / 1024 < 15;
          const isLt1M = file.size / 1021 / 1024 < 1;
          if (!isLt15M) {
            _that.$notify({
              type: "error",
              message: "上传图片大小不能超过 15M！",
            });
            return false;
          } else if (isLt1M) {
            let reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace(
                  "data:image/png;base64,",
                  ""
                );
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  _that.back = res.data.url;
                  _that.infoForm["back"] = res.data.path;
                  _that.infoEditForm["back"] = res.data.path;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  backSuccess = 1;
                } else {
                  _that.$notify({
                    type: "error",
                    message: "照片选择失败！请重新选择。",
                  });
                }
              });
            };
          } else {
            // this.back = URL.createObjectURL(file.raw);
            compress(file.raw, function(val) {
              let newFile = new window.File([val], file.name, {
                type: file.raw.type,
              });
              newFile.uid = file.uid;
              let reader = new FileReader();
              reader.readAsDataURL(newFile);
              reader.onload = (e) => {
                if (e.currentTarget.result.search("png") !== -1) {
                  params.format = "png";
                  let base64 = e.currentTarget.result.replace(
                    "data:image/png;base64,",
                    ""
                  );
                  params.content = base64;
                }
                if (e.currentTarget.result.search("jpeg") !== -1) {
                  params.format = "jpeg";
                  let base64 = e.currentTarget.result.replace(
                    "data:image/jpeg;base64,",
                    ""
                  );
                  params.content = base64;
                }
                postFile(params).then((res) => {
                  if (res.code == 200) {
                    _that.back = res.data.url;
                    _that.infoForm["back"] = res.data.path;
                    _that.infoEditForm["back"] = res.data.path;
                    _that.$notify({
                      type: "success",
                      message: "照片选择成功！",
                    });
                    backSuccess = 1;
                  } else {
                    _that.$notify({
                      type: "error",
                      message: "照片选择失败！请重新选择。",
                    });
                  }
                });
              };
            });
          }
        }
      },
      // 选择器选项
      options() {
        // 所属项目
        postProjectId(this.$store.state.app.projectId).then((res) => {
          this.projectId = res.data.name;
          this.infoForm["projectId"] = res.data.id;
          // 项目下所属的参建单位
          postListUnit(res.data.id).then((res) => {
            this.unitOptions = res.data.map((item) => {
              return { text: item.title, ...item };
            });
          });
        });
        // 所属工种
        postDictCode("work_type").then((res) => {
          this.workTypeOptions = res.data.map((item) => {
            return { text: item.label, ...item };
          });
        });
        // 管理岗位
        postDictCode("management_type").then((res) => {
          this.postOptions = res.data.map((item) => {
            return { text: item.label, ...item };
          });
        });
      },

      // 参建单位
      Unit() {
        this.showUnitPopup = true;
      },
      // 参建单位选择
      onConfirmUnit(value) {
        this.unit = value.title;
        this.infoForm["unitId"] = value.value;
        this.showUnitPopup = false;
        // 参建单位下所属班组
        postListTeam(value.id).then((res) => {
          this.teamOptions = res.data.map((item) => {
            return { text: item.title, ...item };
          });
        });
      },
      // 所属班组
      onConfirmTeam(value) {
        this.team = value.title;
        this.infoForm["teamId"] = value.value;
        this.showTeamPopup = false;
      },
      // 人员类型
      onConfirmPersonnelType(value) {
        if (value.value == 10) {
          this.showPost = true;
        } else if (value.value == 20) {
          this.showPost = false;
        }
        this.personnelType = value.text;
        this.infoForm["personnelType"] = value.value;
        this.showPersonnelTypePopup = false;
      },
      // 管理岗位
      onConfirmPost(value) {
        this.post = value.text;
        this.infoForm["post"] = value.value;
        this.showPostPopup = false;
      },
      // 所属工种
      onConfirmWorkType(value) {
        this.workType = value.label;
        this.infoForm["workType"] = value.value;
        this.showWorkTypePopup = false;
      },
      // 提交表单
      submitForm() {
        if (headSuccess === 1 && frontSuccess === 1 && backSuccess == 1) {
          if (this.$route.params.addOrEdit == "0") {
            this.infoForm.acquisitionMode = 2;
          }
          if (this.$route.params.addOrEdit == "0") {
            this.$refs["infoForm"].validate((valid) => {
              if (valid) {
                postSubmitForm(filtration$(this.infoForm))
                  .then((res) => {
                    if (res.code == 200) {
                      this.$notify({ type: "success", message: "添加成功！" });
                      this.$refs["infoForm"].resetFields();
                      this.$router.push("/certificationRecord");
                    }
                  })
                  .catch((error) => {
                    this.$store.dispatch("submitToken");
                  });
              }
            });
          } else if (this.$route.params.addOrEdit == "1") {
            this.$refs["infoForm"].validate((valid) => {
              if (valid) {
                postSubmitForm(filtration$(this.infoEditForm))
                  .then((res) => {
                    if (res.code == 200) {
                      this.$notify({ type: "success", message: "修改成功！" });
                      // 暂留
                      this.$router.push("/certificationRecord");
                    }
                  })
                  .catch((error) => {
                    this.$store.dispatch("submitToken");
                  });
              }
            });
          }
        } else {
          this.$notify({
            type: "warning",
            message: "请耐心等待照片上传完毕！",
          });
        }
      },
      // 获取编辑详情
      detail() {
        // 认证记录详情
        postDetail(this.$store.state.app.itemId).then((a) => {
          this.head = a.data.head;
          this.front = a.data.front;
          this.back = a.data.back;
          this.infoEditForm["id"] = a.data.id;
          // 所属项目
          postProjectId(a.data.projectId).then((b) => {
            this.project = b.data.name;
          });
          // 项目下所属的参建单位
          postListUnit(a.data.projectId).then((c) => {
            c.data.find((item) => {
              if (a.data.unitId == item.id) {
                this.unit = item.title;
                // 参建单位下所属班组
                postListTeam(item.id).then((e) => {
                  this.teamOptions = e.data.map((item) => {
                    return { text: item.title, ...item };
                    this.$store.dispatch("submitToken");
                  });
                });
              }
            });
            this.unitOptions = c.data.map((item) => {
              return { text: item.title, ...item };
            });
          });
          // 所属班组
          if ("teamId" in a.data == true) {
            postTeamDetail(a.data.teamId).then((d) => {
              this.team = d.data.name;
            });
          }
          // 所属工种
          postDictCode("work_type").then((e) => {
            e.data.find((item) => {
              if (a.data.workType == item.value) {
                this.workType = item.label;
              }
            });
          });
          this.infoForm = a.data;
        });
      },
      // 跳转实名认证记录页面
      authenticationHistory() {
        this.$router.push("/certificationRecord");
      },
    },
  };
</script>
<style lang="less" scoped>
  // 图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
  .bg {
    margin-bottom: 50px;
    min-height: 100vh;
    background-color: #f0f0f0;
  }

  .content {
    padding: 10px;
    /deep/.el-card {
      margin-bottom: 10px;
      .van-uploader:first-child {
        margin-right: 15px;
      }
      p {
        i {
          font-size: 12px;
          white-space: nowrap;
        }
        span {
          font-size: 12px;
        }
      }
      .el-form-item {
        margin: 3px 0 0 0;
      }
      .el-form-item__label {
        padding: 0;
      }
      .el-input__inner {
        border: unset;
        padding: 0;
      }
    }
    .btn {
      display: flex;
      button {
        width: 100%;
      }
    }
  }
  /deep/ .el-dialog {
    width: 100%;
    margin: 0 auto;
  }
  .cropper-content {
    .cropper {
      width: auto;
      height: 330px;
    }
  }
</style>
